import React from "react";
import { Popup } from "@progress/kendo-react-popup";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { icon, label, quote } from "../../../config";
import "./CloseTaskPopup.scss";

/**
 * Anchored confirmation popup for closing a task (same Popup pattern as TaskLockPopover).
 * @author Bhavana
 */
const CloseTaskPopup = ({ show, anchorRef, onCancel, onConfirm, confirmDisabled }) => {
  if (!show) return null;

  return (
    <Popup anchor={anchorRef.current} show={show} popupClass="dt-popup">
      <div className="dt-popup-header d-flex justify-content-between align-items-center">
        <div className="dt-popup-title">{label.FORCE_CLOSE_TASK}</div>
        <span className="dt-popup-cancel-btn cursor-pointer" onClick={onCancel} title={label.CLOSE_POPUP}>
          <Tooltip anchorElement="target" parentTitle={true} position="bottom">
            {icon.CLOSE}
          </Tooltip>
        </span>
      </div>
      <div className="dt-popup-body p-0">
        <article id="close-task-popover" className="close-task-popup p-3 rounded text-left font-weight-normal">
          <div className="close-task-popup__copy">
            <p className="text-justify mb-2">{quote.CLOSE_CONFIRMATION_LEAD}</p>
            <ul className="mb-2 pl-3 ml-2">
              <li className="text-justify">{quote.CLOSE_CONFIRMATION_BULLET_1}</li>
              <li className="text-justify">{quote.CLOSE_CONFIRMATION_BULLET_2}</li>
            </ul>
            <p className="text-justify mb-0">{quote.CLOSE_CONFIRMATION_PROCEED}</p>
          </div>
        </article>
      </div>
      <div className="dt-popup-footer text-right">
        <button type="button" className="btn btn-ghost mr-2" onClick={onCancel}>
          {label.CANCEL}
        </button>
        <button
          type="button"
          id="confirm-close-btn"
          className="btn btn-primary"
          disabled={confirmDisabled}
          onClick={onConfirm}
        >
          {label.CONFIRM_TEXT}
        </button>
      </div>
    </Popup>
  );
};

export default React.memo(CloseTaskPopup);
